import api from '../util/api'
import ApiAdapter from './ApiAdapter'

class ModernApiAdapter extends ApiAdapter {
  async load (customer, slug) {
    const response = await api.get('/planner-windows', {
      params: {
        customerSlug: customer,
        productSlug: slug
      }
    })

    return this.adaptResponse(response.data.data)
  }

  adaptResponse (data) {
    const viewingDates = data.agendaItemWindows.map(window => ({
      id: window.id,
      start: window.start,
      end: window.end,
      time_slots: window.agenda_items.map(item => ({
        viewing_date_id: window.id,
        start: item.start,
        end: item.end,
        request: item.contact_id ? { contact_id: item.contact_id } : null,
        status: item.status,
        agenda_item_id: item.id
      }))
    }))

    return {
      customer: data.customer,
      product: data.product,
      viewing_dates: viewingDates
    }
  }

  async store (viewingRequest) {
    // eslint-disable-next-line camelcase
    const { agenda_item_id, contact, answers, locale } = viewingRequest

    // eslint-disable-next-line camelcase
    if (!agenda_item_id) {
      throw new Error('agenda_item_id is required for modern API')
    }

    // eslint-disable-next-line camelcase
    return api.patch(`/planner-windows/items/${agenda_item_id}`, {
      contact,
      answers,
      locale
    })
  }

  async storeWaitingListSpot (product, contactDetails, answers) {
    // eslint-disable-next-line camelcase
    const params = {
      product_id: product.id,
      contact: contactDetails,
      answers: answers
    }

    // eslint-disable-next-line camelcase
    return api.post('/agenda-waiting-list-spots', params)
  }
}

export default ModernApiAdapter
